import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

class MakanzaPricing extends Component {
  render() {
    const pptPlans = [
      {
        id: "ppt-basic",
        name: "PPT Basic",
        tagline: "Pilihan bijak starter",
        price: "Rp 500",
        period: "per order",
        description: "Flat rate untuk setiap transaksi",
        features: [
          "Menu management",
          "Basic analytics",
          "10 users",
          "Basic reporting",
          "Email support",
        ],
        gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        icon: "pe-7s-rocket",
        buttonText: "Mulai Uji Coba Gratis",
        url: "https://fnb.darma.co.id/register",
      },
      {
        id: "ppt-pro",
        name: "PPT Pro",
        tagline: "Untuk bisnis berkembang",
        price: "2.5%",
        period: "per order",
        description: "Min Rp 1.000, max Rp 5.000",
        features: [
          "Menu management",
          "Basic analytics",
          "Up to 50 users",
          "Advanced reporting",
          "Priority support",
          "Delivery feature",
          "Custom branding",
        ],
        gradient: "linear-gradient(135deg, #ff9a56 0%, #ff6a3d 100%)",
        icon: "pe-7s-graph2",
        buttonText: "Mulai Uji Coba Gratis",
        url: "https://fnb.darma.co.id/register",
        popular: true,
      },
    ];

    const monthlyPlans = [
      {
        id: "talented",
        name: "Talented Plan",
        tagline: "Hemat dengan paket bulanan",
        price: "Rp 99.000",
        period: "/ bulan",
        description: "Rp 25.000 per user tambahan",
        features: [
          "Up to 4 users",
          "Unlimited orders",
          "Full menu management",
          "Advanced analytics",
          "Email & chat support",
        ],
        gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        icon: "pe-7s-star",
        buttonText: "Mulai Uji Coba Gratis",
        url: "https://fnb.darma.co.id/register",
        maxUsers: 4,
        additionalUserPrice: "Rp 25.000",
      },
      {
        id: "prodigy",
        name: "Prodigy Plan",
        tagline: "Untuk tim yang lebih besar",
        price: "Rp 249.000",
        period: "/ bulan",
        description: "Rp 20.000 per user tambahan",
        features: [
          "Up to 11 users",
          "Unlimited orders",
          "Full menu management",
          "Advanced analytics",
          "Priority support",
          "Custom branding",
        ],
        gradient: "linear-gradient(135deg, #ff9a56 0%, #ff6a3d 100%)",
        icon: "pe-7s-cup",
        buttonText: "Mulai Uji Coba Gratis",
        url: "https://fnb.darma.co.id/register",
        popular: true,
        maxUsers: 11,
        additionalUserPrice: "Rp 20.000",
      },
      {
        id: "genius",
        name: "Genius Plan",
        tagline: "Untuk bisnis skala besar",
        price: "Rp 499.000",
        period: "/ bulan",
        description: "Rp 15.000 per user tambahan",
        features: [
          "Up to 25 users",
          "Unlimited orders",
          "Full menu management",
          "Advanced analytics",
          "Dedicated support",
          "Custom branding",
          "API access",
        ],
        gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
        icon: "pe-7s-diamond",
        buttonText: "Mulai Uji Coba Gratis",
        url: "https://fnb.darma.co.id/register",
        maxUsers: 25,
        additionalUserPrice: "Rp 15.000",
      },
    ];

    return (
      <section id="pricing" className="makanza-pricing-section pt100 pb100">
        <Container>
          {/* Section Header */}
          <Row>
            <Col lg="8" md="10" sm="12" className="offset-lg-2 offset-md-1">
              <div className="section-title text-center mb60">
                <h2>
                  Harga <span>Sederhana</span> dan Transparan
                </h2>
                <hr className="lines" />
                <p className="section-subtitle">
                  Pilih paket yang sesuai dengan kebutuhan bisnis Anda. Semua
                  paket termasuk uji coba gratis 14 hari.
                </p>
              </div>
            </Col>
          </Row>

          {/* PPT Plans Section */}
          <Row className="mb-5">
            <Col xs="12">
              <div className="pricing-category-header">
                <h3>Paket Bayar Sesuai Pemakaian</h3>
                <p>Pilihan bijak starter - bayar hanya saat ada penjualan</p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center mb80">
            {pptPlans.map((plan) => (
              <Col lg="5" md="6" sm="12" key={plan.id} className="mb-4">
                <div
                  className={`pricing-card ${plan.popular ? "popular" : ""}`}
                >
                  {plan.popular && (
                    <div className="popular-badge">Paling Populer</div>
                  )}
                  <div
                    className="pricing-card-header"
                    style={{ background: plan.gradient }}
                  >
                    <div className="plan-icon">
                      <i className={plan.icon}></i>
                    </div>
                    <h4 className="plan-name">{plan.name}</h4>
                    <p className="plan-tagline">{plan.tagline}</p>
                  </div>
                  <div className="pricing-card-body">
                    <div className="price-wrapper">
                      <div className="price">{plan.price}</div>
                      <div className="period">{plan.period}</div>
                      <div className="price-description">{plan.description}</div>
                    </div>
                    <ul className="features-list">
                      {plan.features.map((feature, index) => (
                        <li key={index}>
                          <i className="fa fa-check-circle"></i>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <div className="pricing-cta">
                      <a
                        href={plan.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-pricing"
                        style={{ background: plan.gradient }}
                      >
                        {plan.buttonText}
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Monthly Plans Section */}
          <Row className="mb-5">
            <Col xs="12">
              <div className="pricing-category-header">
                <h3>Paket Langganan Bulanan</h3>
                <p>Hemat lebih banyak dengan paket langganan tetap</p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            {monthlyPlans.map((plan) => (
              <Col lg="4" md="6" sm="12" key={plan.id} className="mb-4">
                <div
                  className={`pricing-card ${plan.popular ? "popular" : ""}`}
                >
                  {plan.popular && (
                    <div className="popular-badge">Paling Populer</div>
                  )}
                  <div
                    className="pricing-card-header"
                    style={{ background: plan.gradient }}
                  >
                    <div className="plan-icon">
                      <i className={plan.icon}></i>
                    </div>
                    <h4 className="plan-name">{plan.name}</h4>
                    <p className="plan-tagline">{plan.tagline}</p>
                  </div>
                  <div className="pricing-card-body">
                    <div className="price-wrapper">
                      <div className="price">{plan.price}</div>
                      <div className="period">{plan.period}</div>
                      <div className="price-description">{plan.description}</div>
                    </div>
                    <ul className="features-list">
                      {plan.features.map((feature, index) => (
                        <li key={index}>
                          <i className="fa fa-check-circle"></i>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <div className="pricing-cta">
                      <a
                        href={plan.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-pricing"
                        style={{ background: plan.gradient }}
                      >
                        {plan.buttonText}
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Footer Note */}
          <Row className="mt-5">
            <Col xs="12">
              <div className="pricing-footer-note">
                <p>
                  <i className="fa fa-check-circle"></i> Semua paket termasuk
                  uji coba gratis 14 hari
                </p>
                <p>
                  <i className="fa fa-check-circle"></i> Tanpa kartu kredit
                </p>
                <p>
                  <i className="fa fa-check-circle"></i> Batal kapan saja
                </p>
              </div>
            </Col>
          </Row>
        </Container>

        <style jsx="true">{`
          .makanza-pricing-section {
            background: linear-gradient(180deg, #ffffff 0%, #f8f9ff 100%);
            position: relative;
            overflow: hidden;
          }

          .makanza-pricing-section::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 400px;
            background: radial-gradient(
              circle at 50% 0%,
              rgba(102, 126, 234, 0.08) 0%,
              transparent 70%
            );
            pointer-events: none;
          }

          .section-subtitle {
            font-size: 18px;
            color: #6c757d;
            margin-top: 15px;
            font-weight: 400;
          }

          .pricing-category-header {
            text-align: center;
            margin-bottom: 40px;
          }

          .pricing-category-header h3 {
            font-size: 32px;
            font-weight: 700;
            color: #1a1a2e;
            margin-bottom: 10px;
          }

          .pricing-category-header p {
            font-size: 16px;
            color: #6c757d;
          }

          .pricing-card {
            background: white;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;
            position: relative;
            height: 100%;
            display: flex;
            flex-direction: column;
          }

          .pricing-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
          }

          .pricing-card.popular {
            border: 3px solid #667eea;
            transform: scale(1.05);
          }

          .pricing-card.popular:hover {
            transform: scale(1.05) translateY(-10px);
          }

          .popular-badge {
            position: absolute;
            top: 20px;
            right: -35px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 8px 40px;
            font-size: 12px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 1px;
            transform: rotate(45deg);
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
            z-index: 10;
          }

          .pricing-card-header {
            padding: 40px 30px;
            text-align: center;
            color: white;
            position: relative;
          }

          .plan-icon {
            width: 80px;
            height: 80px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 20px;
            backdrop-filter: blur(10px);
          }

          .plan-icon i {
            font-size: 40px;
            color: white;
          }

          .plan-name {
            font-size: 28px;
            font-weight: 700;
            margin-bottom: 8px;
            color: white;
          }

          .plan-tagline {
            font-size: 14px;
            opacity: 0.9;
            margin: 0;
            color: white;
          }

          .pricing-card-body {
            padding: 40px 30px;
            flex: 1;
            display: flex;
            flex-direction: column;
          }

          .price-wrapper {
            text-align: center;
            margin-bottom: 30px;
            padding-bottom: 30px;
            border-bottom: 2px solid #f0f0f0;
          }

          .price {
            font-size: 42px;
            font-weight: 800;
            color: #ffffff;
            background: linear-gradient(135deg, #1a1a2e 0%, #2d3748 100%);
            padding: 15px 20px;
            border-radius: 12px;
            line-height: 1;
            margin-bottom: 8px;
            display: inline-block;
          }

          .period {
            font-size: 16px;
            color: #6c757d;
            font-weight: 500;
            margin-bottom: 8px;
          }

          .price-description {
            font-size: 14px;
            color: #9ca3af;
            font-style: italic;
          }

          .features-list {
            list-style: none;
            padding: 0;
            margin: 0 0 30px 0;
            flex: 1;
          }

          .features-list li {
            display: flex;
            align-items: flex-start;
            margin-bottom: 15px;
            font-size: 15px;
            color: #4a5568;
          }

          .features-list li i {
            color: #48bb78;
            margin-right: 12px;
            margin-top: 3px;
            font-size: 18px;
            flex-shrink: 0;
          }

          .pricing-cta {
            margin-top: auto;
          }

          .btn-pricing {
            display: block;
            width: 100%;
            padding: 16px 32px;
            border-radius: 50px;
            color: white;
            font-weight: 600;
            font-size: 16px;
            text-decoration: none;
            text-align: center;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
            transition: all 0.3s ease;
            border: none;
          }

          .btn-pricing:hover {
            transform: translateY(-2px);
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25);
            color: white;
            text-decoration: none;
          }

          .pricing-footer-note {
            text-align: center;
            padding: 30px;
            background: rgba(102, 126, 234, 0.05);
            border-radius: 15px;
            margin-top: 20px;
          }

          .pricing-footer-note p {
            display: inline-block;
            margin: 0 20px 10px;
            font-size: 15px;
            color: #4a5568;
            font-weight: 500;
          }

          .pricing-footer-note i {
            color: #48bb78;
            margin-right: 8px;
          }

          @media (max-width: 991px) {
            .pricing-card.popular {
              transform: scale(1);
              margin-bottom: 30px;
            }

            .pricing-card.popular:hover {
              transform: translateY(-10px);
            }

            .plan-name {
              font-size: 24px;
            }

            .price {
              font-size: 36px;
            }

            .pricing-category-header h3 {
              font-size: 26px;
            }

            .pricing-footer-note p {
              display: block;
              margin: 10px 0;
            }
          }

          @media (max-width: 767px) {
            .pricing-card-header {
              padding: 30px 20px;
            }

            .pricing-card-body {
              padding: 30px 20px;
            }

            .plan-icon {
              width: 60px;
              height: 60px;
            }

            .plan-icon i {
              font-size: 30px;
            }
          }
        `}</style>
      </section>
    );
  }
}

export default MakanzaPricing;
